module.exports = __webpack_public_path__ + "static/media/a5-p.a64ad89c.png";